import {eq} from '@shared/helpers/lang'

import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import {getPayLater, PayLaterReloadResponse} from '@web/actions/payLater'
import {PayDue, PayLaterMemberStatus} from '@web/core/constants'
import {PayLaterInfoStatus, PayLaterState} from '@web/slices/payLater/slice'
import makeSlice from '@web/slices/payLater/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

function getStatus(payLater: PayLaterReloadResponse) {
    if (!payLater.availableService) {
        return PayLaterMemberStatus.NOT_AVAILABLE
    }
    if (payLater.newCandidateUser) {
        return PayLaterMemberStatus.SIGNUP
    }
    const eqStatus = eq(payLater.status)
    if (eqStatus('NORMAL')) {
        return PayLaterMemberStatus.NORMAL
    } else if (eqStatus('SUSPENDED')) {
        return PayLaterMemberStatus.SUSPENDED
    } else if (eqStatus('OVERDUE')) {
        return PayLaterMemberStatus.OVERDUE
    }
    return PayLaterMemberStatus.NOT_AVAILABLE
}

function getPayDue(payLater: PayLaterReloadResponse) {
    if (payLater.payDue === 5) {
        return PayDue['5']
    }
    if (payLater.payDue === 15) {
        return PayDue['15']
    }
    if (payLater.payDue === 25) {
        return PayDue['25']
    }
    return null
}

function converOverdue(payLater: PayLaterReloadResponse): PayLaterState['overdue'] {
    return payLater.overduePenaltyStatus
        ? {
              amount: payLater.totalOverdueAmount,
              penaltyStatus: payLater.overduePenaltyStatus,
          }
        : null
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                // 후불결제 정상 가입된 상태일때에만 후불결제 사용 관련 state 복구
                if (state.memberStatus === PayLaterMemberStatus.NORMAL) {
                    const {data} = payload
                    state.enabled = data.payLater.enabled
                    state.useAll = data.payLater.useAll
                    state.usingAmount = data.payLater.usingAmount
                }
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {payMethod} = payload

                state.status = PayLaterInfoStatus.NECESSARY

                state.enabled = payMethod.usePayLaterAsDefault
                state.useAll = payMethod.usePayLaterAll
            })
            .addCase(getPayLater.fulfilled, (state, {payload}) => {
                const payLater = payload
                state.memberStatus = getStatus(payLater)
                state.payDue = getPayDue(payLater)
                state.payDueDate = payLater.payDueDate ?? ''
                state.availableAmount = payLater.availableAmount ?? 0
                state.overdue = converOverdue(payLater)
                state.userInfo.maskedNaverId = payLater?.maskedNaverId ?? null
                if (payLater.testGroupUser) {
                    state.userInfo.isTestGroup = true
                }
            })
    },
})

export default slice.reducer
